export const text = '#656365';
export const primary = '#044117';
export const headerColor = '#fefefe';
export const buttonColor = '#ffffff';
export const background = '#f7f7f7';
export const themeColors = {
    text,
    primary,
    headerColor,
    buttonColor,
    background,
    buttonBgColor: primary,
};
export const fontFamilySansSerif = 'Montserrat, sans-serif';
export const fontFamilyBase = fontFamilySansSerif;
//# sourceMappingURL=variables.js.map